import { useEntitlements, EntitlementsStatus } from 'context/plan'

export const useV1Visible = (): boolean => {
  const { staffUncapped } = useEntitlements()
  return staffUncapped
}

export type StreamsVisibility = 'visible' | 'hidden' | 'pending'

export const resolveStreamsVisibility = ({ staffUncapped, status, streamsReviewerAccess }: {
  staffUncapped: boolean
  status: EntitlementsStatus
  streamsReviewerAccess: boolean
}): StreamsVisibility => {
  if (staffUncapped) return 'visible'
  if (status === 'loading') return 'pending'
  return status === 'ready' && streamsReviewerAccess ? 'visible' : 'hidden'
}

export const streamsSubtreeGuard = (v: StreamsVisibility): 'render' | 'wait' | 'redirect' =>
  v === 'visible' ? 'render' : v === 'pending' ? 'wait' : 'redirect'

export const useStreamsVisibility = (): StreamsVisibility => {
  const { staffUncapped, status, streamsReviewerAccess } = useEntitlements()
  return resolveStreamsVisibility({ staffUncapped, status, streamsReviewerAccess })
}
